import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=15a3aad0&scoped=true"
import script from "./app-footer.vue?vue&type=script&lang=ts"
export * from "./app-footer.vue?vue&type=script&lang=ts"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=15a3aad0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3aad0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a3aad0')) {
      api.createRecord('15a3aad0', component.options)
    } else {
      api.reload('15a3aad0', component.options)
    }
    module.hot.accept("./app-footer.vue?vue&type=template&id=15a3aad0&scoped=true", function () {
      api.rerender('15a3aad0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/partials/app-footer.vue"
export default component.exports